<template>
  <v-row justify="center">
    <v-col cols="12" align="center">
      <div class="footer__title">{{ $t('footer.follow') }}</div>

      <a
        v-for="(icon, index) in icons"
        :key="index"
        :href="icon.link"
        class="footer__icon-link"
        target="_blank"
      >
        <component
          :is="icon.component"
          size="24"
        />
      </a>
    </v-col>
  </v-row>
</template>

<script>
  import {
    FacebookIcon,
    TwitterIcon,
    InstagramIcon,
    YoutubeIcon,
    LinkedinIcon,
  } from 'vue-feather-icons'

  export default {
    name: 'TheFooterSocials',

    data() {
      return {
        icons: [
          {
            component: 'FacebookIcon',
            link: 'https://www.facebook.com/LausanneCapitaleOlympique/'
          },
          {
            component: 'TwitterIcon',
            link: 'https://twitter.com/LausanneCO'
          },
          {
            component: 'InstagramIcon',
            link: 'https://www.instagram.com/thelausanner'
          },
          {
            component: 'YoutubeIcon',
            link: 'https://www.youtube.com/LausanneTourisme'
          },
          {
            component: 'LinkedinIcon',
            link: 'https://www.linkedin.com/company/lausanne-capitale-olympique'
          }
        ]
      }
    },

    components: {
      FacebookIcon,
      TwitterIcon,
      InstagramIcon,
      YoutubeIcon,
      LinkedinIcon,
    },
  }
</script>

<style lang="sass" scoped>
  .footer
    &__icon-link
      margin: 5px 10px
      color: #fff
</style>
